import { render, staticRenderFns } from "./MemoInfo2.vue?vue&type=template&id=0014272b&scoped=true&"
import script from "./MemoInfo2.vue?vue&type=script&lang=js&"
export * from "./MemoInfo2.vue?vue&type=script&lang=js&"
import style0 from "./MemoInfo2.vue?vue&type=style&index=0&id=0014272b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0014272b",
  null
  
)

export default component.exports